import _ from '@/utils/lodash-optimized'
import { Component } from 'react'
import { connect } from 'react-redux'

import {
  USStateCodes,
  NameSuffixCodes,
  ContactPointCodes,
  RelationshipCodes
} from '../../../../../../lib/Codes'
import { titleCase } from '../../../../../../lib/Form'
import { mapPatientToForm } from '../../../../../../lib/Proxy/patient'
import { PlainButton } from '../../../../../shared/Button'
import {
  YesNoRadioOptions,
  bindTargetMixin,
  Collection,
  DateInput,
  Fieldset,
  IconCheckInput,
  MaskedTextInput,
  preferredUpdate,
  QuestionRadioButtonInput,
  SelectInput,
  TextInput,
  today,
  ToggleInput,
  Validators,
  PatientSelect
} from '../../../../../shared/FormBuilder'
import { Paper } from '../../../../../shared/NarusMaterial'

const isImmediateFamily = value => {
  if (!value) {
    return false
  }

  const relationship = RelationshipCodes.find(code => code.value === value)

    return relationship?.immediate ?? false
}

const getOrEmpty = value => (_.isEmpty(value) ? [{}] : value)

const mapCodeForSelect = options =>
  options.map(o => ({
    label: o.display || o.label,
    value: o.code || o.value
  }))

class MemberForm extends bindTargetMixin(Component) {

  constructor (props) {
    super(props)
  }

  getValue = () => ({ ...this.state.value })

  componentDidMount () {
    const value = this.getValue()
    value.phones = getOrEmpty(value.phones)
    value.faxes = getOrEmpty(value.faxes)
    value.emails = getOrEmpty(value.emails)
    this.setState({
      isSubmitting: false,
      value,
      initialValues: value
    })
  }

  componentDidUpdate (prevProps, prevState) {
    const { value } = this.state
    if (value.phones && value.phones.length > 1) {
      preferredUpdate(
        prevState.value.phones,
        this.state.value.phones,
        this.state.value,
        this,
        'phones'
      )
    }
    if (value.emails && value.emails.length > 1) {
      preferredUpdate(
        prevState.value.emails,
        this.state.value.emails,
        this.state.value,
        this,
        'emails'
      )
    }
    this.caregiverStateChange()
    this.validateCareGiver()
    this.validateEmergency()
  }

  forDisplay = (list, attr = 'display') =>
    _.sortBy(
      _.map(list, a =>
        _.merge(a, { label: _.startCase(a[attr].toLowerCase()) })),
      a => a.label.toLowerCase()
    )

  validateCareGiver = () => {
    if (
        !this.state?.value?.narus?.caregiver &&
        this.state?.value?.narus?.differentCareGoals
    ) {
      const newState = this.state.value
      newState.narus.differentCareGoals = undefined
      newState.narus.adequateSupportCaregiver = undefined
      newState.narus.adequateSupportCaregiver = undefined
      this.setState({
        value: newState
      })
    }
  }

  validateEmergency = () => {
    if (
        !this.state?.value?.narus?.emergency &&
        this.state?.value?.narus?.emergencyPrimary
    ) {
      const newState = this.state.value
      newState.narus.emergencyPrimary = undefined
      this.setState({
        value: newState
      })
    }
  }

  caregiverStateChange = () => {
    if (
        (this.state.value?.narus?.isPatientCaregiver ?? 'no') === 'no' &&
        this.state.value?.narus?.helpProvidingCare
    ) {
      const newValueState = this.state.value
      newValueState.narus.helpProvidingCare = undefined
      this.setState({
        value: newValueState
      })
    }
  }

  livesWithPatient = val => {
    const { patient } = this.props
    const unmappedPatient = mapPatientToForm(patient)

    if (!val || val === 'no') {
      this.setInputValue('.address1', undefined)
      this.setInputValue('.address2', undefined)
      this.setInputValue('.city', undefined)
      this.setInputValue('.state', undefined)
      this.setInputValue('.zip', undefined)
      return true
    }

      const address1 = unmappedPatient?.address1
      const address2 = unmappedPatient?.address2
      const state = unmappedPatient?.usState
      const city = unmappedPatient?.city
      const zip = unmappedPatient?.zip

    this.setInputValue('.address1', address1)
    this.setInputValue('.address2', address2)
    this.setInputValue('.city', city)
    this.setInputValue('.state', state)
    this.setInputValue('.zip', zip)

    return true
  }

  renderPrimary () {
    if (
      this.state.value &&
      this.state.value.narus &&
      this.state.value.narus.caregiver &&
      this.state.value.narus.caregiver === true
    ) {
      return (
        <div className='col-xs-12 col-sm-6 col-md-4'>
          <ToggleInput
            label='Primary'
            name='caregiverPrimary'
          />
        </div>
      )
    }
    return false
  }

  renderPrimaryEmergeny () {
    if (
      this.state.value &&
      this.state.value.narus &&
      this.state.value.narus.emergency &&
      this.state.value.narus.emergency === true
    ) {
      return (
        <div className='col-xs-12 col-sm-6 col-md-4'>
          <ToggleInput
            label='Primary'
            name='emergencyPrimary'
          />
        </div>
      )
    }
    return false
  }

  renderDeceased () {
      if (this.state.value?.narus?.living === 'no') {
      return (
        <div>
          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-12'>
              <TextInput
                label='Age deceased'
                name='deceasedAge'
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-12'>
              <TextInput
                label='Cause of death'
                name='causeofDeath'
              />
            </div>
          </div>
        </div>
      )
    }
    return false
  }

  renderHealthIssueDetails () {
      if (this.state.value?.narus?.healthIssues ?? 'no' === 'no') {
      return false
    }

    return (
      <div className='row'>
        <div className='col-xs-12 col-sm-12 col-md-12'>
          <TextInput
            label='Details'
            name='healthIssuesDetails'
          />
        </div>
      </div>
    )
  }

  renderGeneticMarkerDetails () {
      if (this.state.value?.narus?.geneticMarkers ?? 'no' === 'no') {
      return false
    }

    return (
      <div className='row'>
        <div className='col-xs-12 col-sm-12 col-md-12'>
          <TextInput
            label='Details'
            name='geneticMarkersDetails'
          />
        </div>
      </div>
    )
  }

  renderImmediateFamilyForm () {
    if (isImmediateFamily(this.state.value.relationship)) {
      return (
        <div>
          <QuestionRadioButtonInput
            name='living'
            radioButtons={YesNoRadioOptions}
            question='Living?'
          />

          {this.renderDeceased()}

          <QuestionRadioButtonInput
            name='healthIssues'
            radioButtons={YesNoRadioOptions}
            question='Any history of significant health issues?'
          />

          {this.renderHealthIssueDetails()}

          <QuestionRadioButtonInput
            name='geneticMarkers'
            radioButtons={YesNoRadioOptions}
            question='Any history of significant genetic markers?'
          />

          {this.renderGeneticMarkerDetails()}
        </div>
      )
    }
    return false
  }

  handleSubmit = () => {
    const { onSubmit } = this.props
    this.setState({ isSubmitting: true })
    onSubmit(this.getValue())
  }

  handlePatientSelect = patient => {
    if (patient) {
      this.setInputValue('.link', `${patient._clientName}/${patient.id}`)
      this.setInputValue('.firstName', patient.firstName)
      this.setInputValue('.lastName', patient.lastName)
      this.setInputValue('.dob', patient.birthDate)
    }
  }

  filterFunc = obj => {
    const { patient } = this.props
    return obj.id !== patient.id
  }

  render () {
    const { clientName } = this.props
    const { id, relationship, firstName, lastName, link } = this.state.value
    const isNewRecord = _.isNil(id)
    const disableSave = !(relationship && firstName && lastName)
    return (
      <div className='margin-top margin-bottom'>
        {isNewRecord
          ? (
            <div className='nh-margin-bottom-2'>
              <Paper>
                <h2>
                  Patient Search
                </h2>
                <PatientSelect
                  name='search-patient'
                  clientName={clientName}
                  onChange={this.handlePatientSelect}
                  filter={this.filterFunc}
                  label='Search Patient'
                />
              </Paper>
            </div>
          )
          : null}
        <Paper>
          <input
            type='hidden'
            name='id'
          />
          <input
            type='hidden'
            name='link'
          />
          {link && !link?.includes('undefined') && (
            <div className='row'>
              <div className='col-xs-12 col-sm-6 col-md-9' />
              <div className='col-xs-12 col-sm-6 col-md-3'>
                <a
                  href={`/patient/${link}/patientFolder`}
                >
                  {`${lastName}, ${firstName}`}
                </a>
              </div>
            </div>
          )}
          <div className='row'>
            <div className='col-xs-12 col-sm-6 col-md-3'>
              <TextInput
                disabled={link && link.length > 0}
                label='First Name'
                name='firstName'
                required
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-3'>
              <TextInput
                label='Middle Name'
                name='middleName'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-3'>
              <TextInput
                disabled={link && link.length > 0}
                label='Last Name'
                name='lastName'
                required
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-2'>
              <SelectInput
                name='suffix'
                label='Suffix'
                options={NameSuffixCodes}
              />
            </div>
          </div>
          <div className='row margin-bottom'>
            <div className='col-xs-12 col-sm-6 col-md-6'>
              <SelectInput
                name='relationship'
                options={RelationshipCodes.filter(
                  c => c.value !== 'caregiver'
                ).map(c => ({
                  level: c.level,
                  label: titleCase(c.display),
                  value: c.value
                }))}
                label='Relationship'
                required
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-6'>
              <DateInput
                disabled={link && link.length > 0}
                label='Date of Birth'
                name='dob'
                maxDate={today}
              />
            </div>
          </div>

          <Fieldset name='narus'>
            {this.renderImmediateFamilyForm()}

            <div className='margin-top'>
              <QuestionRadioButtonInput
                onChange={this.livesWithPatient}
                question='Lives with patient?'
                name='livesWithPatient'
                radioButtons={YesNoRadioOptions}
              />
            </div>
          </Fieldset>

          <div className='row'>
            <div className='col-xs-12 col-sm-6 col-md-'>
              <TextInput
                label='Address 1'
                name='address1'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-6'>
              <TextInput
                label='Address 2'
                name='address2'
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='City'
                name='city'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <SelectInput
                options={USStateCodes}
                label='State'
                name='state'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <MaskedTextInput
                mask='11111'
                label='Zip'
                name='zip'
              />
            </div>
          </div>

          <Collection name='phones'>
            <Fieldset>
              <div className='checkbox-wrapper'>
                <IconCheckInput
                  name='preferred'
                  checkedIcon='star'
                  uncheckedIcon='star-o'
                />
              </div>
              <div className='row'>
                <div className='col-xs-12 col-sm-5 col-md-5'>
                  <SelectInput
                    name='phoneType'
                    label='Phone Type'
                    options={mapCodeForSelect(
                      ContactPointCodes.contactPointUse
                    )}
                  />
                </div>
                <div className='col-xs-12 col-sm-5 col-md-5'>
                  <MaskedTextInput
                    mask='111.111.1111'
                    name='number'
                    label='Phone Number'
                    validators={[ Validators.phone() ]}
                  />
                </div>
              </div>
            </Fieldset>
          </Collection>

          <Collection name='emails'>
            <Fieldset>
              <div className='checkbox-wrapper'>
                <IconCheckInput
                  name='preferred'
                  checkedIcon='star'
                  uncheckedIcon='star-o'
                />
              </div>
              <div className='row'>
                <div className='col-xs-12 col-sm-10 col-md-10'>
                  <TextInput
                    name='address'
                    label='Email'
                    validators={[ Validators.email() ]}
                  />
                </div>
              </div>
            </Fieldset>
          </Collection>

          <Fieldset name='narus'>
            <div className='row margin-top'>
              <div className='col-xs-12 col-sm-6 col-md-4'>
                <ToggleInput
                  label='Caregiver'
                  labelPosition='right'
                  name='caregiver'
                />
              </div>

              {this.renderPrimary()}
            </div>

            <div className='row'>
              <div className='col-xs-12 col-sm-6 col-md-4'>
                <ToggleInput
                  label='Emergency Contact'
                  name='emergency'
                />
              </div>

              {this.renderPrimaryEmergeny()}
            </div>

            <div className='row'>
              <div className='col-xs-12 col-sm-6 col-md-4'>
                <ToggleInput
                  label='Power of Attorney'
                  name='poa'
                />
              </div>
            </div>

            <div className='row'>
              <div className='col-xs-12 col-sm-6 col-md-4 nh-no-wrap'>
                <ToggleInput
                  label='Permission to discuss case'
                  name='permission'
                />
              </div>
            </div>

            <div className='margin-top'>
              <QuestionRadioButtonInput
                question='Is the patient a caregiver for this person?'
                name='isPatientCaregiver'
                radioButtons={YesNoRadioOptions}
              />
            </div>
          </Fieldset>

          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-12'>
              <h2>Notes</h2>
            </div>
          </div>

          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-12'>
              <TextInput
                label='Notes'
                name='notes'
              />
            </div>
          </div>

          <div className='row end-xs margin-top nh-margin-top-2'>
            <div className='button-container'>
              <PlainButton
                label='Cancel'
                onClick={this.props.onCancel}
              />
              <PlainButton
                label='Save'
                onClick={this.handleSubmit}
                disabled={disableSave || this.state.isSubmitting}
                color='primary'
                btnType='contained'
              />
            </div>
          </div>
        </Paper>
      </div>
    )
  }
}

const mapStateToProps = redux => ({
    patient: Object.values(redux?.patient?.compartment?.Patient ?? {})[0],
  episodeOfCare: Object.values(
      redux?.patient?.compartment?.EpisodeOfCare ?? {}
  )[0],
  clientName: redux.globalVars.params.clientName
})

export default connect(mapStateToProps)(MemberForm)
